import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { Documentospf } from '../../../interface/documentospdf';




@Injectable({
  providedIn: 'root'
})
export class OvService {


  private apiUrl: string = environment.apiPlataforma;



  constructor(private http: HttpClient) { }


  obtener_pdf(token: string, uuid: string | null, documento: string, ramo: string, patente: string, modo: string, poliza_id: string | null, poliza_num: string | null): Observable<Documentospf>
  {
    const url = `${this.apiUrl}/api/v1/ov/documentos_pdf`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const dataToSend = {
      uuid: uuid,
      documento: documento,
      ramo: ramo,
      patente: patente,
      modo: modo,
      poliza_numero: poliza_num,
      poliza_id: poliza_id
    };

    const options = { headers: headers };

    return this.http.post<Documentospf>(url, dataToSend, options);
  }



}
